import { Observable } from 'common/barrels/rx';
import * as alerts from 'common/dom/alerts';

// todo: marshall simultaneous requests to a single auth attempt
export class AuthenticationManager {
    constructor(public authCompleteUri: string = '/authcomplete') {
    }

    public authenticate(authUri: string): Observable<{}> {
        return Observable.create(observer => {

            if (window === window.parent) {
                this.redirectTologin(authUri);
                return;
            }

            // add window event listeners
            window.addEventListener('message', handleAuthComplete);

            // Check if the child window is still open and close it when the parent unloads
            window.addEventListener('beforeunload', closeAuthWindow, { once: true });

            const target = window.origin;
            let authWindow : Window;
            alerts.error("Please click here to login.", "Session Error", true, () => {
                authWindow = this.openAuthWindow(authUri, target);
                authWindow.focus();
            });

            // update observable to signal auth is complete and close auth window
            function handleAuthComplete(event: MessageEvent) {
                if (event.origin === window.origin && event.data === 'authcomplete') {
                    observer.next({});
                    closeAuthWindow();
                }
            }

            function closeAuthWindow() {
                if (authWindow && !authWindow.closed) {
                    authWindow.close();
                }
            }
        });
    }

    private openAuthWindow(authUri: string, windowName: string = "AuthWindow", width: number = 500, height: number = 600,
        // Calculate position for centering the window
        left: number = (window.screen.width / 2) - (width / 2),
        top: number = (window.screen.height / 2) - (height / 2)): Window | null {

        // Open a new window with the specified dimensions and position
        return window.open(authUri, windowName, `width=${width},height=${height},top=${top},left=${left},location=no`);
    }

    private redirectTologin(authUri: string) {
        location.replace(authUri);
    }
}